import { render } from "./SettlementsList.vue?vue&type=template&id=1524967e"
import script from "./SettlementsList.vue?vue&type=script&lang=js"
export * from "./SettlementsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__